import "./RelatedQuestions.css";

interface Props {
  questions: string[];
  onAsk: (q: string) => void;
}

export default function RelatedQuestions({ questions, onAsk }: Props) {
  if (!questions.length) return null;
  return (
    <div className="related-questions">
      <div className="related-questions-label">Related</div>
      <div className="related-questions-list">
        {questions.map((q, i) => (
          <button key={i} className="related-question-btn" onClick={() => onAsk(q)}>
            {q}
          </button>
        ))}
      </div>
    </div>
  );
}
